import { render, staticRenderFns } from "./otheroutreportmanagement.vue?vue&type=template&id=73a74b08&scoped=true&"
import script from "./otheroutreportmanagement.vue?vue&type=script&lang=js&"
export * from "./otheroutreportmanagement.vue?vue&type=script&lang=js&"
import style0 from "./otheroutreportmanagement.vue?vue&type=style&index=0&id=73a74b08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a74b08",
  null
  
)

export default component.exports